module.exports = __webpack_public_path__ + "static/112-fd302f0b84674bf085a60891371f6b25.png";